
import React, { useState } from "react";
import swal from "sweetalert";
import { cashWinnerBankDetail } from "../../actions/StudentAction";
import { useNavigate } from "react-router-dom";

const BankDetailForm = ({ userDetail }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { form_num, name, father_name } = userDetail || {};
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    latestMarkSheet: null,
    studentPassport: null,
    parentPassport: null,
    country: "",
    accountHolderType: "",
    holderName: "",
    accountNumber: "",
    ifscCode: "",
    swiftCode: "",
    bankName: "",
    branchName: "",
    mobileNumber: "",
  });




  const inputFormHandler = (e) => {
    const value = e.target.files ? e.target.files[0] : e.target.value;
    setForm({ ...form, [e.target.name]: value });
    setErrors({...errors, [e.target.name]: ''})

    if(e.target.name ==='holderName' || e.target.name ==='bankName' || e.target.name ==='branchName'){
      let value = e.target.value
      value = value.replace(/[^A-Za-z- ]/ig, '')   
      setForm({ ...form, [e.target.name]: value });
    }
    if(e.target.name ==='accountNumber' || e.target.name ==='mobileNumber'){
        let value = e.target.value
        value = value.replace(/\D/g, '')   
        setForm({ ...form, [e.target.name]: value });
    }
 
  };

  const validation = () => {
    let formIsFalse = true;
    const newErrors = {};
    const requiredFields = [
      "latestMarkSheet",
      "studentPassport",
      "parentPassport",
      "country",
      "accountHolderType",
      "holderName",
      "accountNumber",
      "ifscCode",
      "swiftCode",
      "bankName",
      "branchName",
      "mobileNumber",
    ];

    requiredFields.forEach((field) => {
      if (!form[field]) {
        formIsFalse = false;
        newErrors[field] = `Please provide a ${field}`;
      }
    });

    setErrors(newErrors);
    return formIsFalse;
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!father_name || father_name === '') {
      swal('Please fill all the details in the Family Info Section.', 'After completing that, you will be eligible to submit this form.', 'error');
      return;
    }

    if (validation()) {
      const formData = new FormData();
      formData.append('fno',form_num)
      formData.append('name',name)
      formData.append('country',form.country)
      formData.append('registered_bank_mob',form.mobileNumber)
      formData.append('parent_name',father_name)
      formData.append('bank_ifsc',form.ifscCode)
      formData.append('swiftcode',form.swiftCode)
      formData.append('bank_holder_type',form.accountHolderType)
      formData.append('account_holder_name',form.holderName)
      formData.append('ind_account_num',form.accountNumber)
      formData.append('bank_name',form.bankName)
      formData.append('bank_branch_name',form.branchName)
      // Append file data if available
      if (form.latestMarkSheet) {
        formData.append('marksheet', form.latestMarkSheet);
      }
      if (form.studentPassport) {
        formData.append('student_passport', form.studentPassport);
      }
      if (form.parentPassport) {
        formData.append('parent_passport', form.parentPassport);
      }


      try {
        setLoading(true)
        const res = await cashWinnerBankDetail(formData);
        if (res.status) {
          setLoading(false)
          swal('Bank details submitted successfully', '', 'success');
          navigate('/student/dashboard')
        } else {
          const msg = res.message || 'Something went wrong';
          swal(msg, '', 'error');
          setLoading(false)
        }
      } catch (err) {
        console.error(err);
        setLoading(false);
      }

    }

  };

 

  return (
    <form onSubmit={onSubmit} className="row gy-3 dash-tab">
      <div className="col-lg-12">
        <h6 className="text-black fw-bold">
          Upload Documents <span className="text-danger fs-4">*</span>
        </h6>
      </div>

      <div className="col-lg-4 mt-2 mt-md-auto">
        <div className="form-floating diff_fileUpload">
          <input
            className="form-control"
            type="file"
            name="latestMarkSheet"
            onChange={inputFormHandler}
            accept=".png,.gif,.jpeg,.JPEG,.jpg,.pdf"
          />
          <label className="form-label fw-semibold text-primary">
            Latest Marksheet (Current Grade)
          </label>
          {errors.latestMarkSheet && <small className="invalid-field text-danger fw-semibold mt-2">{errors.latestMarkSheet}</small>}

        </div>
      </div>
      <div className="col-lg-4">
        <div className="form-floating diff_fileUpload">
          <input
            className="form-control"
            type="file"
            name="studentPassport"
            onChange={inputFormHandler}
            accept=".png,.gif,.jpeg,.JPEG,.jpg,.pdf"
          />
          <label className="form-label  fw-semibold text-primary">
            Student Passport Copy
          </label>
          {errors.studentPassport && <small className="invalid-field text-danger fw-semibold mt-2">{errors.studentPassport}</small>}

        </div>
      </div>
      <div className="col-lg-4">
        <div className="form-floating diff_fileUpload">
          <input
            className="form-control"
            type="file"
            name="parentPassport"
            onChange={inputFormHandler}
            accept=".png,.gif,.jpeg,.JPEG,.jpg,.pdf"
          />
          <label className="form-label  fw-semibold text-primary">
            Parent Passport Copy
          </label>
          {errors.parentPassport && <small className="invalid-field text-danger fw-semibold mt-2">{errors.parentPassport}</small>}

        </div>
      </div>

      {/* Bank Detail */}
      <div className="col-lg-12 mt-3">
        <h6 className="text-black fw-bold">
          Bank Details <span className="text-danger fs-4">*</span>
        </h6>
      </div>

      <div className="col-lg-6">
        <label className="form-label">
          Country<span>*</span>
        </label>
        <select
          name="country"
          value={form.country}
          onChange={inputFormHandler}
          className="form-control"
        >
          <option value="">Select country</option>
          <option value="india">India</option>
        </select>
        {errors.country && <small className="invalid-field text-danger fw-semibold mt-2">{errors.country}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
          Bank Account Holder Type<span>*</span>
        </label>
        <select
          name="accountHolderType"
          value={form.accountHolderType}
          onChange={inputFormHandler}
          className="form-control"
        >
          <option value="">Select account type</option>
          <option value="student">Student</option>
          <option value="parent">Parent</option>
        </select>
        {errors.accountHolderType && <small className="invalid-field text-danger fw-semibold mt-2">{errors.accountHolderType}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
          Account Holder Name<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="holderName"
          value={form.holderName}
          onChange={inputFormHandler}
          placeholder="Enter holder name"
        />
     {errors.holderName && <small className="invalid-field text-danger fw-semibold mt-2">{errors.holderName}</small>}

      </div>
      <div className="col-md-6">
        <label className="form-label">
          Indian Bank Account Number<span>*</span>
        </label>
        <input
          type="text"
          name="accountNumber"
          value={form.accountNumber}
          onChange={inputFormHandler}
          className="form-control"
          placeholder="eg.454545645425"
        />
       {errors.accountNumber && <small className="invalid-field text-danger fw-semibold mt-2">{errors.accountNumber}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
          IFSC Code<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="ifscCode"
          value={form.ifscCode}
          onChange={inputFormHandler}
          placeholder="Enter ifsc code"
        />
        {errors.ifscCode && <small className="invalid-field text-danger fw-semibold mt-2">{errors.ifscCode}</small>}

      </div>
      

      <div className="col-md-6">
        <label className="form-label">
          Swift Code<span>*</span>
        </label>
        <input
          type="text"
          name="swiftCode"
          value={form.swiftCode}
          onChange={inputFormHandler}
          className="form-control"
          placeholder="Enter swift code"
        />
      {errors.swiftCode && <small className="invalid-field text-danger fw-semibold mt-2">{errors.swiftCode}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
          Bank Name<span>*</span>
        </label>
        <input
          type="text"
          name="bankName"
          value={form.bankName}
          onChange={inputFormHandler}
          className="form-control"
          placeholder="Enter bank name"
        />
        {errors.bankName && <small className="invalid-field text-danger fw-semibold mt-2">{errors.bankName}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
          Bank Branch Name<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="branchName"
          value={form.branchName}
          onChange={inputFormHandler}
          placeholder="Enter branch name"
        />
     {errors.branchName && <small className="invalid-field text-danger fw-semibold mt-2">{errors.branchName}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
          Mobile Number Register with bank account<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="mobileNumber"
          value={form.mobileNumber}
          onChange={inputFormHandler}
          placeholder="Enter mobile number"
        />
        {errors.mobileNumber && <small className="invalid-field text-danger fw-semibold mt-2">{errors.mobileNumber}</small>}

      </div>

      <div className="col-md-12 text-start mt-3">
        {loading ? (
          <button className="btn btn-default" disabled type="button">
            <span
              className="spinner-grow spinner-grow-sm me-2"
              aria-hidden="true"
            ></span>
            Submiting...
          </button>
        ) : (
          <button type="submit" className="btn btn-default">
            Submit
          </button>
        )}
      </div>

     
    </form>
  );
};

export default BankDetailForm;
